import { observable, makeObservable, toJS } from 'mobx'
import { TILE_CONTENT } from '@mixtiles/web-backend-shared'
import { SinglePhotoTileStore } from './SinglePhotoTileStore'
import { type Artwork } from 'types/art.types'
import type { PhotoBankStore } from '../../photoBankStore/PhotoBankStore'
import type { ArtPhotoTileData } from './tileSchemas'
import { type TilePatchMode } from '../TilePatch'

const SAVE_TILE_KEYS = ['artwork', 'addedFromCategory']
const ART_PATCHABLE_KEYS_WHITELIST = new Set(['artwork'])

export class ArtPhotoTileStore extends SinglePhotoTileStore {
  @observable.deep accessor artwork: Artwork

  @observable accessor addedFromCategory: string | undefined

  constructor(data: ArtPhotoTileData, photoBankStore: PhotoBankStore) {
    super(data, photoBankStore)
    this.artwork = data.artwork
    this.addedFromCategory = data.addedFromCategory
    makeObservable(this)
  }

  get tileContent(): TILE_CONTENT {
    return TILE_CONTENT.ART_PHOTO
  }

  override toTileData(): ArtPhotoTileData {
    return {
      ...super.toTileData(),
      tileContent: TILE_CONTENT.ART_PHOTO,
      artwork: toJS(this.artwork),
      addedFromCategory: this.addedFromCategory,
    }
  }

  get persistenceKeys(): string[] {
    return super.persistenceKeys.concat(SAVE_TILE_KEYS)
  }

  protected override getPatchableKeysWhitelist(
    mode: TilePatchMode
  ): Set<string> {
    return new Set([
      ...super.getPatchableKeysWhitelist(mode),
      ...ART_PATCHABLE_KEYS_WHITELIST,
    ])
  }
}
